import { PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import {
    IForceBrandPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { IUkMigration } from '../../uk-migration/interfaces/IUkMigration';
import { LoaderManager } from '../../../loaders/LoaderManager';
import { UkMigrationElasticEvents } from '../../uk-migration/enums';

const ModuleName = 'ForceBrandPostLoginAction';

export class ForceBrandPostLoginAction extends PostLoginActionBase {
    private get _ukMigrationPromise(): Promise<IUkMigration> {
        return LoaderManager.Instance.UkMigrationLoader.Instance;
    }

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.ForceBrand, ModuleName, state);
    }

    protected override canExecute = (options?: IForceBrandPostLoginOptions): Promise<boolean> => {
        const forceBrandRequired = options?.enabled || false;
        return Promise.resolve(forceBrandRequired);
    };

    protected override doAction = async (): Promise<boolean> => {
        const envelop = { headers: { publisher: ModuleName }, topic: null };
        const trackingEvent = {
            dataString: JSON.stringify({}),
            event: UkMigrationElasticEvents.ForceBrandPostLoginAction,
        };
        this._clientTracking.onSendEvent(trackingEvent, envelop);
        this.clearOptions();
        const ukMigration = await this._ukMigrationPromise;
        this.completeAction();
        ukMigration?.reload();
        return true;
    };
}
